import { render, staticRenderFns } from "./FundingDetailsEmis.vue?vue&type=template&id=2bdc0793&"
import script from "./FundingDetailsEmis.vue?vue&type=script&lang=js&"
export * from "./FundingDetailsEmis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports